// extracted by mini-css-extract-plugin
export default {"sideTab":"BrowserSideTab_sideTab__N66Fi"};